
import { supabase } from "@/integrations/supabase/client";

export const fetchVisibilitySettings = async (contactId: string) => {
  console.log("Fetching visibility settings from Supabase for contact:", contactId);
  
  const { data, error } = await supabase
    .from("contact_section_visibility")
    .select("section_name, is_visible")
    .eq("contact_id", contactId);

  if (error) {
    console.error("Supabase error fetching visibility settings:", error);
    throw error;
  }

  console.log("Raw visibility data:", data);

  return (data || []).reduce((acc, item) => ({
    ...acc,
    [item.section_name]: item.is_visible ?? true
  }), {});
};

export const updateVisibilitySetting = async (
  contactId: string,
  sectionName: string,
  currentVisibility: boolean
) => {
  console.log("Updating visibility setting:", {
    contactId,
    sectionName,
    newVisibility: !currentVisibility
  });

  // Check if record exists
  const { data: existingData, error: checkError } = await supabase
    .from("contact_section_visibility")
    .select("id")
    .eq("contact_id", contactId)
    .eq("section_name", sectionName)
    .maybeSingle();

  if (checkError) {
    console.error("Error checking existing record:", checkError);
    throw checkError;
  }

  if (existingData) {
    // Update existing record
    console.log("Updating existing visibility record");
    const { error } = await supabase
      .from("contact_section_visibility")
      .update({ is_visible: !currentVisibility })
      .eq("contact_id", contactId)
      .eq("section_name", sectionName);

    if (error) {
      console.error("Error updating visibility:", error);
      throw error;
    }
  } else {
    // Insert new record
    console.log("Creating new visibility record");
    const { error } = await supabase
      .from("contact_section_visibility")
      .insert({
        contact_id: contactId,
        section_name: sectionName,
        is_visible: !currentVisibility
      });

    if (error) {
      console.error("Error inserting visibility:", error);
      throw error;
    }
  }
};
